import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { userAgentIsBot } from './ConfigurationHelper';
import Geocode from 'react-geocode';
import strings from 'localization/strings';

const googleMapsLibraries = ['places'];

window.googleMapsScript = {
    isLoaded: false
};

// mechanism to load the Google Maps script only once
export const initializeGoogleMaps = appContext => {
    if(!userAgentIsBot()) {
        window.googleMapsScript = useJsApiLoader({
            googleMapsApiKey: appContext.google.mapsApiKey,
            libraries: googleMapsLibraries,
            language: appContext.language
        });
    }

    Geocode.setApiKey(appContext.google.mapsGeocodingApiKey);
    Geocode.setLocationType('GEOMETRIC_CENTER');
};

export const getGoogleMapsScript = () => {
    return window.googleMapsScript;
};

export const getGoogleMapsLocationLink = location =>
    <a href={`https://www.google.com/maps/search/?api=1&query=${location.latitude}%2C${location.longitude}`} target="_blank">{strings.showInGoogleMaps}</a>;
